// import { FaUserPlus, FaLaptop, FaClipboardList, FaMoneyCheckAlt } from 'react-icons/fa';

// const HowItWorks = () => {
//   return (
//     <div className="py-10 text-center">
//       <h2 className="text-3xl font-semibold text-[#FF9630] mb-6">How It Works</h2>
//       <div className="flex justify-center items-center space-x-8 w-full mx-auto">
        
//         {/* Sign Up as Dealer */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaUserPlus className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Sign Up as Dealer</h3>
//           <p className="text-gray-600 text-sm">Create an account and manage your store online.</p>
//         </div>

//         <span className="border-r-2 border-gray-300 h-16 mx-4"></span>
        
//         {/* Add Your Product */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaLaptop className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Add Your Product</h3>
//           <p className="text-gray-600 text-sm">You can add self-drive bikes.</p>
//         </div>

//         <span className="border-r-2 border-gray-300 h-16 mx-4"></span>

//         {/* Manage Bookings */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaClipboardList className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Manage Bookings</h3>
//           <p className="text-gray-600 text-sm">Receive and track all your bookings.</p>
//         </div>

//         <span className="border-r-2 border-gray-300 h-16 mx-4"></span>

//         {/* Payment Done */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaMoneyCheckAlt className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Payment Done</h3>
//           <p className="text-gray-600 text-sm">Receive your payment in your bank account directly.</p>
//         </div>
        
//       </div>
//     </div>
//   );
// };

// export default HowItWorks;


// import { FaUserPlus, FaLaptop, FaClipboardList, FaMoneyCheckAlt } from 'react-icons/fa';

// const HowItWorks = () => {
//   return (
//     <div className="py-10 text-center">
//       <h2 className="text-3xl font-semibold text-[#FF9630] mb-6">How It Works</h2>
//       <div className="flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-8 w-full mx-auto">
        
//         {/* Sign Up as Dealer */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaUserPlus className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Sign Up as Dealer</h3>
//           <p className="text-gray-600 text-sm">Create an account and manage your store online.</p>
//         </div>

//         {/* Divider */}
//         <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

//         {/* Add Your Product */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaLaptop className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Add Your Product</h3>
//           <p className="text-gray-600 text-sm">You can add self-drive bikes.</p>
//         </div>

//         {/* Divider */}
//         <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

//         {/* Manage Bookings */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaClipboardList className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Manage Bookings</h3>
//           <p className="text-gray-600 text-sm">Receive and track all your bookings.</p>
//         </div>

//         {/* Divider */}
//         <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

//         {/* Payment Done */}
//         <div className="flex flex-col items-center space-y-2">
//           <FaMoneyCheckAlt className="text-5xl text-gray-600" />
//           <h3 className="text-lg font-semibold text-blue-600">Payment Done</h3>
//           <p className="text-gray-600 text-sm">Receive your payment in your bank account directly.</p>
//         </div>
        
//       </div>
//     </div>
//   );
// };

// export default HowItWorks;

import React from "react";
import signUpImage from "../assets/add-user.png";
import addProductImage from "../assets/add-product.png";
import manageBookingsImage from "../assets/manage-bookings.png";
import paymentDoneImage from "../assets/payment-method.png";

const HowItWorks = () => {
  return (
    <div className="py-10 text-center">
      <h2 className="text-3xl font-semibold text-[#FF9630] mb-6">How It Works</h2>
      <div className="flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-8 w-full mx-auto mt-12">
        
        {/* Sign Up as Dealer */}
        <div className="flex flex-col items-center space-y-2">
          <img src={signUpImage} alt="Sign Up" className="w-20 h-20 object-contain" />
          <h3 className="text-lg font-semibold text-blue-600">Sign Up as Dealer</h3>
          <p className="text-gray-600 text-sm">Create an account and manage your</p>
          <p className="text-gray-600 text-sm">store online.</p>
        </div>

        {/* Divider */}
        <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

        {/* Add Your Product */}
        <div className="flex flex-col items-center space-y-2">
          <img src={addProductImage} alt="Add Product" className="w-20 h-20 object-contain" />
          <h3 className="text-lg font-semibold text-blue-600">Add Your Product</h3>
          <p className="text-gray-600 text-sm">You can add self-drive bikes.</p>
        </div>

        {/* Divider */}
        <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

        {/* Manage Bookings */}
        <div className="flex flex-col items-center space-y-2">
          <img src={manageBookingsImage} alt="Manage Bookings" className="w-20 h-20 object-contain" />
          <h3 className="text-lg font-semibold text-blue-600">Manage Bookings</h3>
          <p className="text-gray-600 text-sm">Receive and track all your bookings.</p>
        </div>

        {/* Divider */}
        <span className="hidden md:inline-block border-r-2 border-gray-300 h-16 mx-4"></span>

        {/* Payment Done */}
        <div className="flex flex-col items-center space-y-2">
          <img src={paymentDoneImage} alt="Payment Done" className="w-20 h-20 object-contain" />
          <h3 className="text-lg font-semibold text-blue-600">Payment Done</h3>
          <p className="text-gray-600 text-sm">Receive your payment in your bank </p>
          <p className="text-gray-600 text-sm">account directly.</p>
        </div>
        
      </div>
    </div>
  );
};

export default HowItWorks;
